import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PageMetaWithTotalSchema, PageQuerySchema } from '../pagination';
import { ReleaseEnvironmentSchema } from '../release-products/shapes';
import { ReleaseRowSchema, ReleaseStatusSchema } from './shapes';

export const ListReleasesQuerySchema = PageQuerySchema.pick({
  limit: true,
  cursor: true,
  q: true,
}).extend({
  productId: z.string().uuid().optional(),
  environment: ReleaseEnvironmentSchema.optional(),
  status: ReleaseStatusSchema.optional(),
});

export const listReleases = defineEndpoint({
  method: 'GET',
  path: '/v1/releases',
  params: z.object({}),
  query: ListReleasesQuerySchema,
  body: z.undefined(),
  response: z.object({
    data: z.array(ReleaseRowSchema),
    meta: PageMetaWithTotalSchema,
  }),
});
